import * as React from 'react';
var Pen = function (_a) {
    var title = _a.title, titleId = _a.titleId;
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", "aria-labelledby": titleId },
        title ? React.createElement("title", { id: titleId }, title) : null,
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "m15.13 5.12 3.75 3.75 1.83-1.83a.996.996 0 0 0 0-1.41l-2.34-2.34a.996.996 0 0 0-1.41 0l-1.83 1.83ZM3 21v-3.75L14.06 6.19l3.75 3.75L6.75 21H3Zm3-2 8.982-9.06-.922-.922L5 18l.5.5.5.5Z" })));
};
export default Pen;
//# sourceMappingURL=Pen.js.map